import { IHelpContexts } from "./../types/HelpVideosTypes";
import { atom } from "recoil";
import { HelpVideoNameMap } from "../types/HelpVideosTypes";

export interface ISettingsHelpVideos {
  helpTitle: string;

  helpContext:
    | IHelpContexts.SettingsGeneral
    | IHelpContexts.SettingsContacts
    | IHelpContexts.SettingsBilling
    | IHelpContexts.SettingsSecurity
    | IHelpContexts.SettingsApiKey
    | IHelpContexts.SettingsBlocking
    | IHelpContexts.SettingsUsers
    | IHelpContexts.SettingsIntegrations
    | IHelpContexts.SettingsLearnisticIntegration
    | IHelpContexts.SettingsThrivecartIntegration
    | IHelpContexts.DNSRecords
    | IHelpContexts.AfterPurchaseThankYouPage
    | IHelpContexts.GettingStarted;
}

export const SettingsHelpVideosAtom = atom<ISettingsHelpVideos>({
  key: "SettingsHelpVideosAtom",
  default: {
    helpTitle: HelpVideoNameMap[IHelpContexts.SettingsGeneral],
    helpContext: IHelpContexts.SettingsGeneral,
  },
});
